import PropTypes from 'prop-types';

const SocialNetworkIds = (props) => {
  const { socialIds } = props;
  const result = [];

  if (socialIds.gplus_id) {
    result.push(`Gplus ID - ${socialIds.gplus_id}`);
  }
  if (socialIds.vk_id) {
    result.push(`VK ID - ${socialIds.vk_id}`);
  }
  if (socialIds.facebook_id) {
    result.push(`Facebook ID - ${socialIds.facebook_id}`);
  }
  if (socialIds.draugiem_id) {
    result.push(`Draugiem ID - ${socialIds.draugiem_id}`);
  }

  if (!result.length) {
    result.push('-');
  }

  return result.join(', ');
};

SocialNetworkIds.propTypes = {
  socialIds: PropTypes.shape({
    gplus_id: PropTypes.string,
    vk_id: PropTypes.string,
    facebook_id: PropTypes.string,
    draugiem_id: PropTypes.string,
  }),
};

SocialNetworkIds.defaultProps = {
  socialIds: {
    gplus_id: '',
    vk_id: '',
    facebook_id: '',
    draugiem_id: '',
  },
};

export default SocialNetworkIds;
